//campaign City report
export const CampaignCityReport = {
  // City Summary
  GET_CITY_OVERVIEW: "GET_CITY_OVERVIEW",
  GET_CITY_OVERVIEW_SUCCESS: "GET_CITY_OVERVIEW_SUCCESS",
  GET_CITY_OVERVIEW_FAILURE: "GET_CITY_OVERVIEW_FAILURE",

  // Approx ots for city
  APPROX_OTS_FOR_CITY: "APPROX_OTS_FOR_CITY",
  APPROX_OTS_FOR_CITY_SUCCESS: "APPROX_OTS_FOR_CITY_SUCCESS",
  APPROX_OTS_FOR_CITY_FAILURE: "APPROX_OTS_FOR_CITY_FAILURE",

  // City summary report
  DOWNLOAD_CITY_PDF_REPORT: "DOWNLOAD_CITY_PDF_REPORT",
  DOWNLOAD_CITY_PDF_REPORT_SUCCESS: "DOWNLOAD_CITY_PDF_REPORT_SUCCESS",
  DOWNLOAD_CITY_PDF_REPORT_FAILURE: "DOWNLOAD_CITY_PDF_REPORT_FAILURE",
  RESET_CITY_PDF_REPORT: "RESET_CITY_PDF_REPORT",

  // City medias reports as zip
  DOWNLOAD_CITY_MEDIAS_PDF_REPORTS_ZIP: "DOWNLOAD_CITY_MEDIAS_PDF_REPORTS_ZIP",
  DOWNLOAD_CITY_MEDIAS_PDF_REPORTS_ZIP_SUCCESS:
    "DOWNLOAD_CITY_MEDIAS_PDF_REPORTS_ZIP_SUCCESS",
  DOWNLOAD_CITY_MEDIAS_PDF_REPORTS_ZIP_FAILURE:
    "DOWNLOAD_CITY_MEDIAS_PDF_REPORTS_ZIP_FAILURE",
  RESET_CITY_MEDIAS_PDF_REPORTS_ZIP: "RESET_CITY_MEDIAS_PDF_REPORTS_ZIP",

  // City Medias Single Pdf Report
  DOWNLOAD_CITY_MEDIAS_SINGLE_PDF_REPORT:
    "DOWNLOAD_CITY_MEDIAS_SINGLE_PDF_REPORT",
  DOWNLOAD_CITY_MEDIAS_SINGLE_PDF_REPORT_SUCCESS:
    "DOWNLOAD_CITY_MEDIAS_SINGLE_PDF_REPORT_SUCCESS",
  DOWNLOAD_CITY_MEDIAS_SINGLE_PDF_REPORT_FAILURE:
    "DOWNLOAD_CITY_MEDIAS_SINGLE_PDF_REPORT_FAILURE",
  RESET_CITY_MEDIAS_SINGLE_PDF_REPORT: "RESET_CITY_MEDIAS_SINGLE_PDF_REPORT",

  // Download Campaign City Reports Form
  OPEN_DOWNLOAD_CAMPAIGN_CITY_REPORT_MODAL:
    "OPEN_DOWNLOAD_CAMPAIGN_CITY_REPORT_MODAL",
  CLOSE_DOWNLOAD_CAMPAIGN_CITY_REPORT_MODAL:
    "CLOSE_DOWNLOAD_CAMPAIGN_CITY_REPORT_MODAL",
};
